import { createTheme } from '@mui/material/styles';

const memberSiteTheme = createTheme({
    typography: {
        htmlFontSize: 10,
    },
});

export default memberSiteTheme;
